import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductMyAvatar } from '@/features/user/avatar'

/**
 * O sufixo `_` em `minha-conta_` desaninha esta rota do layout de
 * `minha-conta.tsx`: a URL fica dentro da área, mas o editor renderiza sua
 * própria árvore, sem a faixa de navegação e sem o `max-w-2xl` do `Screen`.
 *
 * É uma superfície de manipulação direta — zoom, pan e tour guiado — e não um
 * formulário; espremê-la na largura de leitura degradaria a edição.
 */
export const Route = createFileRoute('/_event/minha-conta_/avatar')({
  component: DigitalProductMyAvatarPage
})

function DigitalProductMyAvatarPage() {
  return <DigitalProductMyAvatar />
}
